import hash from 'object-hash';

/**
 * This function checks if response is still valid
 * and returns cached response, so no api request is needed
 * @param actionName
 * @param cachingDuration
 * @param parameters
 * @param thunkAPI
 * @returns boolean
 */
export function isCacheValid(
  actionName: string,
  parameters: any,
  thunkAPI: any
) {
  const state = thunkAPI.getState();
  const cacheDuration = parameters.cacheDuration;
  const key = cacheActionKey(actionName, parameters);
  const lastModified = state.cache.actions[key];

  if (lastModified) {
    return lastModified + cacheDuration > new Date().getTime();
  }

  return false;
}

export function cacheActionKey(actionName: string, parameters: any) {
  const params = {
    ...parameters,
  };
  delete params.cacheDuration;

  const hashKey = hash(params);
  const key = `${actionName}-${hashKey}`;

  return key;
}
